const FALLBACK_SITE_URL = 'https://www.drdetoxer.com';

function normalizeSiteUrl(rawUrl?: string): string {
  if (!rawUrl) return FALLBACK_SITE_URL;

  const withScheme = /^https?:\/\//i.test(rawUrl) ? rawUrl : `https://${rawUrl}`;

  try {
    const url = new URL(withScheme);
    if (url.hostname === 'drdetoxer.com') {
      url.hostname = 'www.drdetoxer.com';
    }
    return url.origin;
  } catch {
    return FALLBACK_SITE_URL;
  }
}

export const SITE_URL = normalizeSiteUrl(process.env.NEXT_PUBLIC_SITE_URL);
